import { Outlet, useLocation } from 'react-router';
import Header from '../Header/Header';
import BottomNav from '../BottomNav/BottomNav';

export default function MainLayout() {
  const location = useLocation();

  return (
    <div className='app-container'>
      <Header />
      <main style={{ marginBottom: '120px' }}>
        <div key={location.pathname} className='route-motion-screen'>
          <Outlet /> {/* Renders nested route content */}
        </div>
      </main>
      <BottomNav />
    </div>
  );
}
